import { axiosInstance as axios } from "./axiosInstance";

export const requestStep5 = ({ apiConfigs, data, onSuccess }) => {
  const { cgeBaseUrl, pimClient: PimClient } = apiConfigs;

  return axios({
    method: "post",
    url: `${cgeBaseUrl}/api/uterum/step5`,
    headers: {
      PimClient,
    },
    data,
  })
    .then((response) => {
      if (response.data === null) {
        console.error(
          `response.data is null for response: ${JSON.stringify(response)}`
        );
        return null;
      }

      return onSuccess(response);
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
      }
      console.error(error.config);
    });
};
